<template>
	<div class="users top-section-spacing">
		<Header active="Users"/>
		<TopSection
			heading="Create/ Manage Users"
			user="J K"
			searchLabel="name/ email"
			v-model="searchValue"
			/>
		<v-container class="pt-3 table-container">
			<v-layout row wrap class="table-row blue py-2 px-4 cc__box-shadow relative">
				<v-flex xs2 class="pl-3">
					<span class="white--text subheading font-weight-bold">Name</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.firstName ? 'asc' : ''}`" @click="sortBy('firstName')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs2 lg3>
					<span class="white--text subheading font-weight-bold">Email</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.email ? 'asc' : ''}`" @click="sortBy('email')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs2 lg1>
					<span class="white--text subheading font-weight-bold">Contract</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.contractId ? 'asc' : ''}`" @click="sortBy('contractId')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs1>
					<span class="white--text subheading font-weight-bold">Contract Type</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.contractType ? 'asc' : ''}`" @click="sortBy('contractType')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs2>
					<span class="white--text subheading font-weight-bold">Authentication</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.permittedLoginType ? 'asc' : ''}`" @click="sortBy('permittedLoginType')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs1>
					<span class="white--text subheading font-weight-bold">Contract Status</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.contractStatus ? 'asc' : ''}`" @click="sortBy('contractStatus')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
				<v-flex class="pl-3" xs1>
					<span class="white--text subheading font-weight-bold">User Status</span>
					<v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.userStatus ? 'asc' : ''}`" @click="sortBy('userStatus')">
						<v-icon class="white--text title">expand_more</v-icon>
					</v-btn>
				</v-flex>
                <v-flex class="pl-3" xs1 justify-center>
					<span class="white--text subheading font-weight-bold">Edit</span>
				</v-flex>
			</v-layout>
			<simplebar scrollbarMinSize=5 data-simplebar-auto-hide="false" class="list-scroll-section">

				<div v-if="!filteredList.length || noData" class="request-info">
					<div v-if="noData" class="title grey--text">No data available</div>
					<v-progress-circular v-if="!filteredList.length && !noData && noSearchResults" :size="50" indeterminate color="blue"></v-progress-circular>
				</div>

				<div v-for="(user, index) in filteredList" :key="`user-${index}`" class="table-content">
					<v-layout white row wrap class="table-row py-2 px-4">
						<v-flex xs2 class="pl-3">
                            <span class="primary--text subheading">{{ (user.firstName || "") + " " + (user.surname || "" )}}</span>
						</v-flex>
						<v-flex class="pl-3" xs2 lg3>
							<span class="primary--text subheading word-break">{{ user.email }}</span>
						</v-flex>
						<v-flex class="pl-3" xs2 lg1>
                            <span class="primary--text subheading">{{ user.contractId }}</span>
						</v-flex>
						<v-flex class="pl-3" xs1>
							<span class="primary--text subheading">{{ user.contractType }}</span>
						</v-flex>
						<v-flex class="pl-3" xs2>
							<span class="primary--text subheading">{{ user.permittedLoginType }}</span>
						</v-flex>
						<v-flex class="pl-3" xs1>
                            <span class="primary--text subheading">{{ user.contractStatus }}</span>
						</v-flex>
						<v-flex class="pl-3" xs1>
                            <span class="primary--text subheading">{{ user.status }}</span>
						</v-flex>
						<v-flex class="pl-3" xs1 justify-center>
							<v-btn :href="`/user/${user.userId}`" flat class="blue--text text--darken-1 text-capitalize font-weight-regular subheading link">Edit</v-btn>
						</v-flex>
					</v-layout>
					<v-divider></v-divider>
				</div>

			</simplebar>
			<v-btn href="/user" large color="blue" class="mt-4 mr-5 pl-4 pr-3 text-icon-button ml-0 large-button-width">
				<span class="white--text subheading text-capitalize font-weight-bold pl-3">Add User</span>
				<v-icon right class="white--text title">add</v-icon>
			</v-btn>

			<v-btn href="/add-users" large color="blue" class="mt-4 pl-4 pr-3 text-icon-button ml-0 large-button-width">
				<span class="white--text subheading text-capitalize font-weight-bold pl-3">Add Multiple Users</span>
				<v-icon right class="white--text title">add</v-icon>
			</v-btn>
			
		</v-container>
	</div>
</template>

<script>
    let asc = {
		name: false,
		email: false,
		contract: false,
		contractType: false,
		contractStatus: false,
		userStatus: false
	}
	import TopSection from '../components/TopSection.vue'
	import Header from '../components/Header.vue'
    import simplebar from 'simplebar-vue'
    import userService from '../services/user'

	export default {
		name: 'App',
		components: {
			Header, TopSection, simplebar
		},
		data() {
            return {
				noData: false,
				contractTypes: [],
                companyId: sessionStorage.companyId,
				asc,
				searchValue: '',
                users: null,
				teams: null,
	  			noSearchResults: false				
			}
        },
        methods: {
            async fetchData() {
				this.users = await userService.getAll(this.companyId);
				if(this.users.data.length == 0){
					this.noData = true;
				 }
            },
            sortBy(prop) {
                if (this.users) {
                    this.asc[prop] = !this.asc[prop]
                    if (this.asc[prop]) {
                        this.users.data.sort((a, b) => a[prop] < b[prop] ? -1 : 1)
                    } else {
                        this.users.data.sort((a, b) => a[prop] > b[prop] ? -1 : 1)
                    }
                }
			}
		},
		computed: {
            filteredList() {
                if (this.users) {
					this.noSearchResults = false;
                    return this.users.data.filter(user => {
						return (user.firstName || '').toLowerCase().includes(this.searchValue.toLowerCase()) ||
							(user.surname || '').toLowerCase().includes(this.searchValue.toLowerCase()) ||
							user.email.toLowerCase().includes(this.searchValue.toLowerCase())
                    })
                } else {
					this.noSearchResults = true;
                    return [];
                }
			}
        },
        created() {
            this.fetchData();
        }
	}

</script>



